
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ArrowForwardIos } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';
import { ROUTING_CONFIG } from '@uplift/constants';

export type ContactSupportProps = {
  isMobile: boolean;
  onClick?: () => void;
};

export const ContactSupport: React.FC<ContactSupportProps> = ({ isMobile }) => {
  const l10n = useL10n();
  const { classes } = useStyles();

  return (
    <Box mt={3} display="flex" alignItems="center" gap="8px" px={isMobile ? 2 : 0}>
      <Typography variant="body1" color="textSecondary">
        {l10n.accountSettings.billing.outOfPocketQuestions}
      </Typography>
      <a
        className={classes.contactSupportLink}
        href={ROUTING_CONFIG.support}
        target="_blank"
        rel="noreferrer"
      >
        {isMobile ? <ArrowForwardIos fontSize="small" /> : l10n.pages.contactSupport}
      </a>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  contactSupportLink: {
    color: theme.palette.secondary.main,
    fontWeight: 700,
    textDecoration: 'none',
  },
}));
